import { render, staticRenderFns } from "./HeaderBottom.vue?vue&type=template&id=10768007&scoped=true&lang=pug&"
import script from "./HeaderBottom.vue?vue&type=script&lang=js&"
export * from "./HeaderBottom.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBottom.vue?vue&type=style&index=0&id=10768007&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10768007",
  null
  
)

export default component.exports